import { cn } from '../../components/ui/utils';

interface SettingsGroupProps {
  title: string;
  className?: string;
}

/**
 * Заголовок группы настроек. Двадцать контролов подряд читаются как сплошная
 * лента — подписи разбивают их на разделы, по которым глаз цепляется при
 * прокрутке.
 */
export function SettingsGroup({ title, className }: SettingsGroupProps): JSX.Element {
  return (
    <div className={cn('flex items-center gap-3 pt-2 first:pt-0', className)}>
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {title}
      </span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
